<template>
  <main id="create-quote-page" class="page-container">
    <!-- ▸ TASTO INDIETRO -->
    <button class="back-btn" @click="goBack" aria-label="Torna ai preventivi">
      <font-awesome-icon :icon="['fas', 'arrow-left']" />
      Indietro
    </button>

    <!-- Messaggi di errore e successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Container in alto a destra per il pulsante toggle -->
    <div class="toggle-list-btn-container">
      <button
        @click="toggleItemsList"
        class="toggle-list-btn"
        :class="{ shifted: showItemsList }"
      >
        <img
          v-if="!showItemsList"
          :src="require('@/assets/plus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        <img
          v-else
          :src="require('@/assets/minus_Icon.png')"
          alt="toggle-list"
          class="icon"
        />
        {{ showItemsList ? "Nascondi" : "Mostra" }} lista articoli
      </button>
    </div>

    <!-- Modale per lista articoli -->
    <VueFinalModal
      v-model="showItemsList"
      :clickToClose="true"
      :escToClose="true"
      classes="items-list-modal"
      content-class="items-list-modal-content"
    >
      <template #default>
        <button class="modal__close" @click="toggleItemsList">
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>

        <h3 class="modal__title">Articoli aggiunti</h3>

        <div class="items-table-wrap">
          <table class="items-table" :style="{ '--item-col-w': itemColWidth }">
            <colgroup>
              <!-- 1) Articolo: dinamica in base ai caratteri -->
              <col :style="{ width: itemColWidth }" />
              <!-- 2) Le altre: auto con min-width gestita da CSS -->
              <col />
              <col />
              <col />
              <col />
              <col />
              <col />
            </colgroup>

            <thead>
              <tr>
                <th>Articolo</th>
                <th>Quantità</th>
                <th>Articolo minore</th>
                <th>Zona</th>
                <th>Categoria</th>
                <th>Prezzo</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in formData.items" :key="index">
                <!-- Colonna Articolo: title + meta -->
                <td class="item-cell">
                  <div class="item-title">
                    {{ itemDisplay(item).title }}
                  </div>
                  <div v-if="itemDisplay(item).meta" class="item-meta">
                    {{ itemDisplay(item).meta }}
                  </div>
                </td>

                <td>{{ item.quantity }}</td>
                <td>{{ item.subItem ? "Sì" : "No" }}</td>
                <td>
                  <font-awesome-icon
                    :icon="['fas', 'location-dot']"
                    class="cell-icon"
                  />
                  {{ item.area || "—" }}
                </td>
                <td>
                  <font-awesome-icon
                    :icon="[
                      'fas',
                      categoryIcon(
                        (getItemFromStore(item.itemId) || {}).category
                      ),
                    ]"
                    class="cell-icon"
                  />
                  {{ (getItemFromStore(item.itemId) || {}).category || "—" }}
                </td>
                <td>{{ formatPrice(item.price) }}</td>
                <td>
                  <button
                    class="icons-button"
                    @click="removeItem(index)"
                    title="Rimuovi articolo dalla lista"
                    aria-label="Rimuovi articolo dalla lista"
                  >
                    <font-awesome-icon :icon="['fas', 'trash-can']" />
                  </button>
                </td>
              </tr>

              <tr v-if="formData.items.length === 0">
                <td colspan="7" class="no-result">Nessun articolo presente</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </VueFinalModal>

    <!-- Form principale -->
    <form
      class="create-quote-form"
      @submit.prevent="onCreateQuoteAndGeneratePDF"
    >
      <!-- Riepilogo date (visibile solo quando valide) -->
      <div v-if="dateSummary" class="date-summary-bar">
        <span><strong>Inizio:</strong> {{ dateSummary.start }}</span>
        <span class="date-summary-sep">→</span>
        <span><strong>Fine:</strong> {{ dateSummary.end }}</span>
      </div>

      <!-- RIGA 1: Seleziona Cliente, date, operatore, evento, luogo, zona -->
      <div class="create-quote-row row-1">
        <!-- Seleziona Cliente -->
        <div class="field">
          <label for="client-select">Seleziona Cliente</label>
          <select v-model="formData.clientId" id="client-select" required>
            <option value="" disabled selected>seleziona</option>
            <option
              v-for="client in clients"
              :key="client.id"
              :value="client.id"
            >
              {{ client.clientName }}
            </option>
          </select>
        </div>

        <!-- Seleziona Operatori -->
        <div class="field">
          <label>Seleziona Operatori</label>
          <OperatorsMultiSelect
            v-model="formData.operatorIds"
            :operators="operators"
          />
        </div>

        <!-- Periodo noleggio -->
        <div class="field">
          <label>Periodo noleggio</label>
          <DateRangePicker
            :startDate="formData.rentStartDate"
            :endDate="formData.rentEndDate"
            :allQuotes="allQuotes"
            :currentQuoteId="null"
            :invalid="dateRangeInvalid"
            :errorMsg="dateRangeError"
            @update:startDate="formData.rentStartDate = $event"
            @update:endDate="formData.rentEndDate = $event"
          />
        </div>

        <!-- Nome evento -->
        <div class="field">
          <label for="event-name">Nome Evento</label>
          <input
            id="event-name"
            type="text"
            v-model="formData.eventName"
            placeholder="Inserisci il nome dell'evento"
          />
        </div>

        <!-- Località -->
        <div class="field">
          <label for="autocomplete">Luogo</label>
          <input
            type="text"
            id="autocomplete"
            v-model="formData.location.address"
            placeholder="Inserisci un luogo"
            style="width: 200px"
          />
        </div>

        <!-- Aggiungi Zona -->
        <div class="field">
          <label for="new-area">Crea zona</label>
          <div class="inline-input-btn">
            <input
              id="new-area"
              type="text"
              v-model="newArea"
              placeholder="notte, giorno…"
            />
            <button type="button" @click="addArea">+</button>
          </div>
        </div>

        <!-- Elenco zone aggiunte -->
        <div v-if="areas.length > 0" class="field area-zones-section">
          <label>Elenco zone</label>
          <div class="area-chips">
            <span
              v-for="area in areas"
              :key="area"
              class="area-chip"
              :class="{ 'area-chip--selected': newItem.area === area }"
              @click="newItem.area = area"
            >
              {{ area }}
              <button
                type="button"
                class="area-chip__remove"
                @click.stop="removeArea(area)"
                title="Rimuovi zona"
              >
                ×
              </button>
            </span>
          </div>
        </div>
      </div>

      <hr />

      <!-- RIGA 4: scegli articolo, quantità e prezzo -->
      <div class="create-quote-row row-4">
        <!-- scegli Articolo -->
        <div class="field" id="item-select">
          <label for="item-search">Articolo</label>
          <div class="searchable-select">
            <input
              type="text"
              v-model="searchQuery"
              placeholder="Cerca articolo..."
              class="search-input"
              @focus="onSearchFocus"
              @blur="hideDropdown"
              @keydown="handleKey"
              autocomplete="off"
            />
            <Teleport to="body">
              <ul
                v-if="showDropdown && filteredItems.length > 0"
                class="search-results-list"
                :style="dropdownStyle"
                @mousedown.prevent
              >
                <li
                  v-for="(item, index) in filteredItems"
                  :key="item.id"
                  :class="{ highlighted: index === selectedIndex }"
                  @mousedown.prevent="selectItem(item)"
                >
                  {{ item.itemName }}
                </li>
              </ul>

              <!-- "Nessun risultato" — separato, appare solo se dropdown aperto ma lista vuota -->
              <ul
                v-if="
                  showDropdown &&
                  filteredItems.length === 0 &&
                  searchQuery.length > 0
                "
                class="search-results-list"
                :style="dropdownStyle"
              >
                <li class="no-result">Nessun risultato</li>
              </ul>
            </Teleport>
          </div>
        </div>

        <!-- scelta subItem -->
        <div class="field">
          <label>Articolo minore?</label>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" v-model="newItem.subItem" :value="false" /> No
            </label>
            <label class="radio-label">
              <input type="radio" v-model="newItem.subItem" :value="true" /> Sì
            </label>
          </div>
        </div>

        <!-- Scegli quantità -->
        <div class="field">
          <label for="quantity">Quantità</label>
          <input
            id="quantity"
            type="number"
            v-model="newItem.quantity"
            placeholder="Inserisci quantità"
          />
        </div>

        <!-- Scegli Prezzo -->
        <div
          class="field"
          :class="{ 'field--disabled': newItem.subItem === true }"
        >
          <label for="price">Prezzo</label>
          <input
            id="price"
            type="number"
            v-model="newItem.price"
            placeholder="Inserisci prezzo"
            :disabled="newItem.subItem === true"
            :required="newItem.subItem === false"
            step="0.01"
          />
        </div>
      </div>

      <!-- RIGA 5: bottone "+ aggiungi articolo" -->
      <div class="create-quote-row row-5">
        <div class="field">
          <button type="button" id="create-quote-button" @click="addItem">
            <span> + articolo</span>
          </button>
        </div>
      </div>
    </form>

    <hr />

    <!-- RIGA 6: richieste tecniche + lingua PDF -->
    <div class="create-quote-row row-6">
      <!-- Richieste tecniche -->
      <div class="field">
        <label for="technical-requests">Richieste tecniche</label>
        <textarea
          id="technical-requests"
          v-model="formData.technical_queries"
          placeholder="Inserisci richieste tecniche"
        ></textarea>
      </div>

      <!-- Lingua PDF -->
      <div class="field">
        <label for="lang-select">Lingua PDF:</label>
        <select v-model="$i18n.locale" id="lang-select" class="pdf-lang-select">
          <option value="it">Italiano</option>
          <option value="en">English</option>
        </select>
      </div>
    </div>

    <!-- Bottoni Salva / PDF -->
    <div class="save-button-container">
      <button
        class="form-quote-button"
        type="submit"
        @click="onCreateQuoteAndGeneratePDF"
      >
        Salva ed esporta PDF
      </button>
    </div>

    <!-- ▸ MODAL ABBANDONA FORM -->
    <div v-if="showLeaveModal" class="modal-overlay">
      <div class="modal">
        <button
          class="modal__close icons-button"
          @click="cancelLeave"
          title="Rimani"
          aria-label="Rimani"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
        <h3 class="modal__title">Modifiche non salvate</h3>
        <p class="modal__subtitle">
          Hai modifiche non salvate. Vuoi abbandonare la pagina?
        </p>
        <div class="modal-actions">
          <button class="danger-btn" @click="confirmLeave">Abbandona</button>
          <button class="primary-btn" @click="cancelLeave">Rimani</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import logoPath from "@/assets/4AllEvent_logo.png";
// import crypto from "crypto";
import jsPDF from "jspdf";
import { useToast } from "vue-toast-notification";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { formatToLocalDate } from "../utilities/formatting.js";
import OperatorsMultiSelect from "@/components/OperatorsMultiSelect.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  components: { OperatorsMultiSelect, DateRangePicker },
  setup() {
    const toast = useToast();
    return { toast };
  },
  created() {
    this.$store.dispatch("fetchClients");
    this.$store.dispatch("fetchOperators");
    this.$store.dispatch("fetchItems");
    this.$store.dispatch("fetchQuotes");
  },
  computed: {
    clients() {
      return this.$store.getters["clients/list"];
    },
    operators() {
      return this.$store.getters["operators/nonAdmin"];
    },
    items() {
      return this.$store.getters["items/list"];
    },
    allQuotes() {
      return this.$store.getters["quotes/list"];
    },

    filteredItems() {
      return this.items
        .filter((item) =>
          item.itemName.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
        .slice(0, 5); // Mostra solo i primi 5 risultati
    },
    // Tutti i nomi da mostrare nella colonna "Articolo"
    itemNames() {
      return (this.formData.items || []).map(
        (row) => this.getItemName(row.itemId) || ""
      );
    },

    // Lunghezza massima in caratteri tra i nomi
    maxItemLen() {
      return this.itemNames.reduce((m, s) => Math.max(m, s.length), 0);
    },

    // Larghezza dinamica della colonna "Articolo" in ch, con limiti
    // - min 180px
    // - valore centrale in ch = maxItemLen + 6
    // - max 50vw
    itemColWidth() {
      const ch = Math.max(10, Math.min(this.maxItemLen + 6, 72)); // clamp logico
      return `clamp(180px, ${ch}ch, 50vw)`;
    },
    dropdownStyle() {
      if (!this.inputRect) return {};
      return {
        position: "fixed",
        top: `${this.inputRect.bottom + 4}px`,
        left: `${this.inputRect.left}px`,
        width: `${this.inputRect.width}px`,
        zIndex: 9999,
      };
    },
    dateSummary() {
      if (
        !this.formData.rentStartDate ||
        !this.formData.rentEndDate ||
        this.dateRangeInvalid
      )
        return null;
      const fmt = (val) => {
        const [date, time] = val.split("T");
        const [y, m, d] = date.split("-");
        return `${d}/${m}/${y} ${time}`;
      };
      return {
        start: fmt(this.formData.rentStartDate),
        end: fmt(this.formData.rentEndDate),
      };
    },
    dateRangeError() {
      if (!this.formData.rentStartDate || !this.formData.rentEndDate)
        return null;
      const start = new Date(this.formData.rentStartDate);
      const end = new Date(this.formData.rentEndDate);
      if (start >= end) {
        const sameDay = start.toDateString() === end.toDateString();
        return sameDay
          ? "L'orario di inizio deve essere precedente all'orario di fine"
          : "La data di inizio deve essere precedente alla data di fine";
      }
      return null;
    },
    dateRangeInvalid() {
      return !!this.dateRangeError;
    },
  },
  data() {
    return {
      showDropdown: false,
      searchQuery: "",
      showItemsList: false,
      selectedIndex: -1, // Indice dell'opzione attualmente evidenziata
      response: "",
      image: logoPath,
      isDirty: false,
      showLeaveModal: false,
      pendingNavigation: null,
      pendingCancel: null,
      formData: {
        eventName: "",
        location: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        operatorIds: [],
        rentStartDate: "",
        rentEndDate: "",
      },
      newItem: {
        subItem: false,
        area: "",
        // category: "",
        itemId: null,
        quantity: "",
        price: "",
      },
      areas: [],
      categories: [],
      newArea: "", // Per aggiungere una nuova zona
      categoryIconMap: {
        "fari a batteria": "battery-full",
        "illuminotecnica scenica rgb": "lightbulb",
        "controllo luci": "sliders",
        audio: "volume-high",
        "mixer & mic": "microphone",
        video: "video",
        "video control": "display",
        "notebook-mac": "laptop",
        "stage & truss": "layer-group",
        "distribuzione elettrica": "plug",
        veicoli: "truck",
      },
      newCategory: "",
      // errorMessage: "",
      // successMessage: "",
      selectedPlaceId: "",
      inputRect: null, // per posizionare il dropdown
    };
  },
  /* global google */
  // serve questo commento per far funzionare il metodo google alla riga 501?!
  methods: {
    getItemFromStore(id) {
      // Find the item in your store's fetched array:
      const found = this.items.find((fetchedItem) => fetchedItem.id === id);
      return found ? found : {}; // Return the full object or an empty one
    },
    // Mappa l'azione createItem dallo store
    ...mapActions(["createItem", "uploadQuoteDocument"]),

    toggleItemsList() {
      this.showItemsList = !this.showItemsList;
    },

    // Ritorna solo il titolo (usato da itemNames)
    getItemName(id) {
      const it = this.getItemFromStore(id) || {};
      return this.itemDisplayFromObj(it).title;
    },

    // Usato nel template per ottenere { title, meta } da una riga della tabella
    itemDisplay(item) {
      const it = this.getItemFromStore(item.itemId) || {};
      return this.itemDisplayFromObj(it);
    },

    // Variante per ID, se mai ti dovesse servire
    itemDisplayById(id) {
      const it = this.getItemFromStore(id) || {};
      return this.itemDisplayFromObj(it);
    },

    // 🔹 Logica finale: title + meta (model + category)
    itemDisplayFromObj(it = {}) {
      const rawTitle = (it.itemName || "Articolo").toString().trim();
      const title = rawTitle || "Articolo";

      const parts = [];
      if (it.model) parts.push(it.model);
      if (it.category) parts.push(it.category);

      const meta = parts.join(" – ");

      return { title, meta };
    },

    handleKey(event) {
      // Se il dropdown non è mostrato, non fare nulla
      if (!this.showDropdown) return;

      if (event.key === "ArrowDown") {
        // Freccia giù: incrementa l'indice
        if (this.selectedIndex < this.filteredItems.length - 1) {
          this.selectedIndex++;
        } else {
          this.selectedIndex = 0;
        }
        event.preventDefault();
      } else if (event.key === "ArrowUp") {
        // Freccia su: decrementa l'indice
        if (this.selectedIndex > 0) {
          this.selectedIndex--;
        } else {
          this.selectedIndex = this.filteredItems.length - 1;
        }
        event.preventDefault();
      } else if (event.key === "Enter") {
        // Se si preme Enter, seleziona l'elemento evidenziato
        if (
          this.selectedIndex >= 0 &&
          this.selectedIndex < this.filteredItems.length
        ) {
          this.newItem.itemId = this.filteredItems[this.selectedIndex].id;
          // Puoi aggiornare anche la searchQuery per mostrare il nome selezionato
          this.searchQuery = this.filteredItems[this.selectedIndex].itemName;
          this.showDropdown = false;
        }
        event.preventDefault();
      }
    },

    hideDropdown() {
      // Usa un timeout per permettere il click di selezione sul dropdown prima di nasconderlo
      setTimeout(() => {
        this.showDropdown = false;
        this.selectedIndex = -1; // Aggiungi questa linea per resettare l'indice
      }, 300);
    },

    /**
     * Gestisce la selezione di un articolo dal dropdown.
     * Chiude il dropdown e aggiorna la searchQuery con il nome dell'articolo selezionato.
     */
    // handleSelection() {
    //   this.showDropdown = false;
    //   this.searchQuery = this.getItemName(this.newItem.itemId);
    // },
    selectItem(item) {
      this.newItem.itemId = item.id;
      this.searchQuery = item.itemName;
      this.showDropdown = false;
      this.selectedIndex = -1;
    },
    // Aggiorna la posizione del dropdown quando si apre
    updateDropdownPosition() {
      const input = document.querySelector(".search-input");
      if (input) {
        this.inputRect = input.getBoundingClientRect();
      }
    },
    // Sovrascrivi il focus handler esistente
    onSearchFocus() {
      this.updateDropdownPosition();
      this.showDropdown = true;
    },
    addItem() {
      // this.errorMessage = "";
      if (
        !this.newItem.itemId ||
        !this.newItem.quantity ||
        (!this.newItem.price && this.newItem.subItem === false)
        // !this.newItem.area ||
        // !this.newItem.category
        // !this.newItem.price
      ) {
        if (!this.newItem.subItem === true) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            "Non puoi omettere il prezzo se l'articolo non è un articolo minore."
          );
          // });
          return;
        }
        // this.$nextTick(() => {
        // this.errorMessage =
        this.toast.error(
          "Compila tutti i campi prima di aggiungere un articolo."
        );
        // });
        return;
      }

      if (!this.newItem.price && this.newItem.subItem === true) {
        this.newItem.price = 0;
      }

      // Trova se esiste un elemento con le stesse caratteristiche
      const existingItem = this.formData.items.find(
        (item) =>
          item.itemId === this.newItem.itemId &&
          item.area === this.newItem.area &&
          // item.category === this.newItem.category &&
          item.price === this.newItem.price
      );

      if (existingItem) {
        // Se esiste, aumenta la quantità
        existingItem.quantity += parseFloat(this.newItem.quantity);
        // this.successMessage =
        this.toast.success("Quantità aggiornata per l'articolo esistente.");
      } else {
        // Altrimenti, aggiungi un nuovo articolo
        this.formData.items.push({ ...this.newItem });
        // this.successMessage =
        this.toast.success("Articolo aggiunto con successo.");
      }

      // Resetta i campi del nuovo articolo
      this.newItem = {
        ...this.newItem,
        itemId: "",
        quantity: "",
        price: "",
      };

      this.searchQuery = ""; // Resetta la query di ricerca
      this.showDropdown = false; // Nascondi i risultati
      // this.errorMessage = ""; // Resetta eventuali errori
    },

    removeItem(index) {
      this.formData.items.splice(index, 1);
    },

    saveToLocalStorage(key, data) {
      localStorage.setItem(key, JSON.stringify(data));
    },

    loadFromLocalStorage(key) {
      const savedData = localStorage.getItem(key);
      if (savedData) {
        return JSON.parse(savedData);
      }
      return null;
    },

    // getItemName(itemId) {
    //   const item = this.items.find((i) => i.id === itemId);
    //   return item ? item.itemName : "Sconosciuto";
    // },

    formatToLocalDate,

    categoryIcon(category) {
      if (!category) return "tag";
      return this.categoryIconMap[category.toLowerCase().trim()] || "tag";
    },
    formatPrice(price) {
      const currencySymbol = "€"; // Cambia in "$" per il dollaro
      return `${currencySymbol} ${parseFloat(price).toFixed(2)}`;
    },

    addArea() {
      if (!this.newArea.trim()) {
        this.toast.warning(
          "È necessario inserire una zona prima di poterla aggiungere"
        );
        return;
      }
      if (!this.areas.includes(this.newArea.trim())) {
        const trimmed = this.newArea.trim();
        this.areas.push(trimmed);
        this.newItem.area = trimmed; // seleziona automaticamente l'ultima zona aggiunta
        this.saveToLocalStorage("areas", this.areas);
        this.newArea = ""; // Resetta il campo
      } else {
        this.toast.warning("La zona è già presente tra le zone disponibili");
      }
    },

    removeArea(area) {
      this.areas = this.areas.filter((a) => a !== area);
      this.saveToLocalStorage("areas", this.areas);
      // se la zona rimossa era quella selezionata, deseleziona
      if (this.newItem.area === area) this.newItem.area = "";
    },

    async onCreateQuoteAndGeneratePDF(generatePDF = true) {
      // this.errorMessage = "";
      // this.successMessage = "";

      // Controllo base: almeno un articolo presente
      if (this.formData.items.length === 0) {
        // this.$nextTick(() => {
        // this.errorMessage =
        this.toast.error("Aggiungi almeno un articolo prima di salvare");
        // });
        return;
      }
      if (this.dateRangeInvalid) {
        this.toast.error(this.dateRangeError);
        return;
      }
      try {
        // Aggiungi automaticamente l'articolo se i campi sono stati riempiti
        if (
          this.newItem.itemId &&
          this.newItem.quantity
          // this.newItem.price
        ) {
          this.formData.items.push({ ...this.newItem });
        }
        const payload = {
          ...this.formData,
          technical_queries: (this.formData.technical_queries || "").trim(),
        };

        const sanitize = (s) => (s || "").replace(/\p{C}+/gu, "");
        payload.technical_queries = sanitize(payload.technical_queries);

        const response = await this.$store.dispatch("createQuote", payload);
        this.response = response;
        // console.log("response: ", response);

        if (response.status === 200 || response.status === 201) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data.message || "Preventivo creato con successo!"
          );
          // });

          const warnings = response.data.warnings ?? [];
          if (warnings.length > 0) {
            setTimeout(() => {
              warnings.forEach((warning) => this.toast.warning(warning));
            }, 2000);
          }

          if (generatePDF) {
            await this.generatePDF();
          }
          // reset dei campi
          this.newItem = {
            subItem: false,
            area: "",
            // category: "",
            itemId: "",
            quantity: "",
            price: "",
          };
          // Svuota lista articoli
          this.formData.items = [];
        } else {
          // Per sicurezza, se arriva un 200 strano, gestisci anche qui
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            response.data.details || "Impossibile creare il preventivo."
          );
          // });
          // this.successMessage = "";
        }
      } catch (error) {
        // Se arrivi qui, c’è un errore => error.response esiste
        if (error.response?.status === 409) {
          // Gestisci il conflitto
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, un preventivo con questi dati esiste già."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante la creazione del preventivo."
          );
          // });
        }
        // this.successMessage = "";
      }
    },

    // Nuova versione con generazione PDF
    async generatePDF() {
      if (!this.response || !this.response.data || !this.response.data.quote) {
        console.error("Nessuna risposta disponibile per generare il PDF.");
        return;
      }

      const doc = new jsPDF();
      const quote = this.response.data.quote;
      const { $t } = this;

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 10;
      const marginY = 10;
      let x = marginX;
      let y = marginY;

      // =========================
      // 1) LOGO E INTESTAZIONE
      // =========================
      if (this.image) {
        try {
          doc.addImage(this.image, "PNG", x, y, 30, 40);
        } catch (error) {
          console.error("Errore durante l'aggiunta del logo:", error);
        }
      }

      // Info aziendali
      doc.setFont("helvetica", "normal").setFontSize(9);
      const topRightX = pageWidth - 70;
      let topRightY = y + 5;
      [
        "Viale della libertà 21, 95040 Ramacca ( CT )",
        "P.IVA: 05459100870",
        "SDI: M5UXCR1",
        "amministrazione@4allevent.it",
        "(+39) 3207928979",
      ].forEach((text) => {
        doc.text(text, topRightX, topRightY);
        topRightY += 4;
      });

      // =========================
      // FUNZIONE LABEL-VALUE
      // =========================
      const printLabelValue = (label, value, xPos, yPos, maxWidth = null) => {
        doc.setFont("helvetica", "bolditalic").setFontSize(11);
        doc.text(`${label}:`, xPos, yPos);
        const offset = doc.getTextWidth(`${label}: `) + 0.8;
        doc.setFont("helvetica", "normal");
        if (maxWidth) {
          const wrapped = doc.splitTextToSize(
            value || "N/D",
            maxWidth - offset
          );
          wrapped.forEach((ln, idx) =>
            doc.text(ln, xPos + offset, yPos + idx * 5)
          );
          return yPos + wrapped.length * 5;
        } else {
          doc.text(value || "N/D", xPos + offset, yPos);
          return yPos + 5;
        }
      };

      // =========================
      // 2) DATI PREVENTIVO
      // =========================
      let contentY = y + 55;

      doc
        .setFont("helvetica", "bold")
        .setFontSize(14)
        .text($t("quoteDetails"), x, contentY);
      contentY += 10;

      // Luogo e indirizzo
      const q = quote.newQuote;
      const loc =
        (q.location &&
          (() => {
            try {
              return JSON.parse(q.location);
            } catch {
              return { address: q.location };
            }
          })()) ||
        {};

      // — stampa dettagli
      contentY = printLabelValue(
        $t("date"),
        `inizio ${
          this.formatToLocalDate(q.rentStartDate) || $t("noData")
        } - fine ${this.formatToLocalDate(q.rentEndDate) || $t("noData")} (${
          quote.daysCount
        })`,
        x,
        contentY
      );

      contentY = printLabelValue(
        $t("client"),
        q.clientName || $t("noData"),
        x,
        contentY
      );

      contentY = printLabelValue(
        $t("eventName"),
        q.eventName || $t("noData"),
        x,
        contentY
      );

      contentY = printLabelValue(
        $t("location"),
        loc.address || $t("noData"),
        x,
        contentY
      );

      // Dettaglio link Google Maps
      if (loc.link) {
        const label = `${$t("mapLink")}: `;
        const link = loc.link;
        const cleanLink = link.replace(/^https?:\/\//, "");
        const maxChars = 19;
        const display =
          cleanLink.length > maxChars
            ? cleanLink.slice(0, maxChars) + "…"
            : cleanLink;

        // Calcola offset identico a printLabelValue
        doc.setFont("helvetica", "bolditalic").setFontSize(11);
        doc.text(`${label}:`, x, contentY);
        const offset = doc.getTextWidth(`${label}: `) + 0.8;

        // Stampa link cliccabile accanto alla label
        doc
          .setFont("helvetica", "bold")
          .setFontSize(10)
          .setTextColor(0, 0, 255);
        doc.textWithLink(display, x + offset, contentY, { url: link });

        // Ripristina stile
        doc.setTextColor(0).setFont("helvetica", "normal").setFontSize(11);
        contentY += 6;
      }

      doc.setDrawColor(150).line(x, contentY, pageWidth - x, contentY);
      contentY += 10;

      // =========================
      // 3) TABELLA ARTICOLI / ZONE
      // =========================
      const colLeftWidth = pageWidth * 0.6 - 20;
      const colRightWidth = pageWidth * 0.3;

      // Intestazioni
      doc
        .setFillColor(200, 200, 200)
        .rect(x, contentY, colLeftWidth, 10, "F")
        .rect(x + colLeftWidth + 10, contentY, colRightWidth, 10, "F")
        .setFont("helvetica", "bold")
        .setFontSize(11)
        .setTextColor(0, 0, 0)
        .text($t("itemsList"), x + 5, contentY + 7)
        .text($t("areas"), x + colLeftWidth + 15, contentY + 7);

      contentY += 15;

      const items = q.items.filter((i) => i.subItem === false) || [];
      console.log("items dentro creazione pdf", items);
      const itemsByArea = items.reduce((acc, item) => {
        const area = item.area || "Generale";
        if (!acc[area]) acc[area] = [];
        acc[area].push(item);
        return acc;
      }, {});

      for (const area in itemsByArea) {
        if (!Object.prototype.hasOwnProperty.call(itemsByArea, area)) continue;
        if (contentY > pageHeight - 100) {
          doc.addPage();
          contentY = 15;
        }

        let localY = contentY;
        itemsByArea[area].forEach((item) => {
          const itemName = item.itemName || "N/D";
          const maxWidth = colLeftWidth - 20;

          // Nome articolo con wrapping
          doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(0);
          const wrappedName = doc.splitTextToSize(`• ${itemName}`, maxWidth);
          doc.text(wrappedName, x + 5, localY);
          const nameBlockHeight = wrappedName.length * 5;

          // Riga dettagli sotto il nome
          const detailY = localY + nameBlockHeight + 1;
          const priceIsKnown = !item.subItem;
          const priceValueTxt = priceIsKnown ? String(item.price || 0) : "";
          const priceSepTxt = priceIsKnown
            ? ` | ${$t("price")}: € `
            : ` | ${$t("noData")}`;
          const categoryTxt = `${$t("category")}: ${
            item.category || $t("noData")
          }`;
          const qtyLabel = `${$t("quantity")}: `;
          const qtyValue = String(item.quantity || 1);
          const afterPriceTxt = ` | ${categoryTxt}`;

          doc.setFontSize(9).setTextColor(80, 80, 80);
          let curX = x + 10;

          doc.text(qtyLabel, curX, detailY);
          curX += doc.getTextWidth(qtyLabel);

          doc.setTextColor(30, 110, 200).setFont("helvetica", "bold"); // quantità in blu
          doc.text(qtyValue, curX, detailY);
          curX += doc.getTextWidth(qtyValue);

          doc.setFont("helvetica", "normal").setTextColor(80, 80, 80);
          doc.text(priceSepTxt, curX, detailY);
          curX += doc.getTextWidth(priceSepTxt);

          if (priceIsKnown) {
            doc.setTextColor(30, 110, 200).setFont("helvetica", "bold"); // prezzo in blu
            doc.text(priceValueTxt, curX, detailY);
            curX += doc.getTextWidth(priceValueTxt);
            doc.setFont("helvetica", "normal").setTextColor(80, 80, 80);
          }

          doc.text(afterPriceTxt, curX, detailY);
          doc.setTextColor(0);

          localY += nameBlockHeight + 8;
          if (localY > pageHeight - 30) {
            doc.addPage();
            localY = 15;
          }
        });

        doc
          .setFont("helvetica", "bold")
          .setFontSize(12)
          .text(area.toUpperCase(), x + colLeftWidth + 15, contentY + 5);
        contentY = Math.max(localY, contentY + 50);
        doc.setDrawColor(200).line(x, contentY, pageWidth - x, contentY);
        contentY += 10;
      }

      // =========================
      // 4) FOOTER MIGLIORATO
      // =========================
      const footerBlockHeight = 65; // Aumentato per includere l’ultima riga + margine
      if (pageHeight - contentY < footerBlockHeight) {
        doc.addPage();
        contentY = marginY;
      }

      // Sfondo grigio chiaro
      doc.setFillColor(240, 240, 240);
      doc.rect(marginX, contentY, pageWidth - 2 * marginX, 55, "F");

      // ▸ Colonna sinistra — RIEPILOGO
      let fy = contentY + 12;
      doc.setFont("helvetica", "bold").setFontSize(12);
      doc.text("Riepilogo", marginX + 8, fy);
      fy += 8;
      doc.setFont("helvetica", "normal").setFontSize(11);
      doc.text(
        `${$t("total")}: € ${Number(
          quote.totalPriceWithoutSubItems || 0
        ).toFixed(2)}`,
        marginX + 8,
        fy
      );

      // ▸ Colonna centrale — DETTAGLI PAGAMENTO (centrato)
      const centerX = pageWidth / 2;
      let py = contentY + 12;
      doc.setFont("helvetica", "bold").setFontSize(12);
      doc.text(`${$t("paymentDetails")}`, centerX, py, { align: "center" });
      doc.setFont("helvetica", "normal").setFontSize(10);
      py += 8;

      const paymentLines = [
        "IBAN: IT03S0623084153000015064464",
        "Intestato a: 4ALL EVENT SRL",
        "BIC/SWIFT: CRPPIT2PXXX",
        "CRÈDIT AGRICOLE – RAMACCA (CT) 95040 – VIA ROMA 38/40",
      ];
      paymentLines.forEach((line) => {
        doc.text(line, centerX, py, { align: "center" });
        py += 7;
      });

      // ▸ Colonna destra — FIRMA
      const rightPadding = 4;
      const sigEnd = pageWidth - marginX - rightPadding;
      const sigWidth = 32;
      const sigStart = sigEnd - sigWidth;

      doc.setFont("helvetica", "bold").setFontSize(11);
      doc.text(`${$t("signature")}`, sigStart, contentY + 12);
      doc.setDrawColor(0).line(sigStart, contentY + 22, sigEnd, contentY + 22);

      contentY += 60; // più spazio sotto al footer

      // ▸ Richieste tecniche (se presenti)
      if (q.technical_queries) {
        if (pageHeight - contentY < 20) {
          doc.addPage();
          contentY = marginY;
        }
        doc.setFont("helvetica", "italic").setFontSize(8);
        const txt = doc.splitTextToSize(
          `${q.technical_queries}`,
          pageWidth - 2 * marginX
        );
        doc.text(txt, marginX, contentY);
      }

      // =========================
      // SALVATAGGIO PDF
      // =========================
      const quoteId = q.id;
      const filenameBase = `${$t("quote")}_${"N"}_${quoteId}.pdf`;
      const isDev =
        process.env.NODE_ENV === "development" ||
        process.env?.VUE_APP_NODE_ENV === "development";

      // helper FE (senza 'path')
      const withSuffixBeforeExt = (filename, suffix) => {
        if (!suffix) return filename;
        const dot = filename.lastIndexOf(".");
        if (dot <= 0) return `${filename}.${suffix}`;
        return `${filename.slice(0, dot)}.${suffix}${filename.slice(dot)}`;
      };

      const finalName = withSuffixBeforeExt(filenameBase, isDev ? "dev" : "");
      const blob = doc.output("blob");
      // 👇 crea un "File" con nome giusto, così Multer lo vede come originalname
      const file = new File([blob], finalName, { type: "application/pdf" });

      try {
        await this.$store.dispatch("uploadQuoteDocument", {
          quoteId,
          document: file,
          filename: finalName,
        });
        doc.save(finalName);
        // this.$nextTick(() => {
        // this.successMessage =
        this.toast.success("PDF generato e caricato con successo!");
        // });
      } catch (error) {
        // console.error("Errore durante l'upload del PDF:", error);
        // this.$nextTick(() => {
        this.toast.error(
          (this.errorMessage =
            error.response?.data?.details ||
            error.response?.data?.error ||
            "Errore durante il caricamento del PDF.")
        );
        // });
      }

      // Reset campi e redirect
      this.formData = {
        eventName: "",
        location: {
          name: "",
          address: "",
          placeId: "",
          latitude: "",
          longitude: "",
        },
        technical_queries: "",
        clientId: "",
        items: [],
        operatorIds: [],
        rentStartDate: "",
        rentEndDate: "",
      };

      setTimeout(() => {
        this.isDirty = false;
        this.$router.push({ name: "quotes" });
        this.$store.dispatch("fetchQuotes");
        // this.successMessage = "";
        // this.errorMessage = "";
      }, 1000);
    },

    initAutocomplete() {
      const input = document.getElementById("autocomplete");
      if (!input) {
        // console.error("L'input autocomplete non è stato trovato.");
        return;
      }

      const autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.setFields([
        "geometry",
        "name",
        "place_id",
        "formatted_address",
      ]);
      /**fare il controllo sugli articoli aggiunti, se articolo con area, prezzo e categoria uguale allora aumentare solo quantità
       * possibilità di omettere il prezzo solo se subItem=true
       *
       */

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place.place_id && place.geometry && place.formatted_address) {
          this.formData.location = {
            name: place.name,
            address: place.formatted_address,
            place_id: place.place_id,
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
          };
        } else {
          console.error("Nessun placeId disponibile");
        }
      });
    },

    handlePlaceChange() {
      // Puoi gestire azioni aggiuntive dopo il cambio del luogo
    },

    goBack() {
      if (this.isDirty) {
        this.pendingNavigation = () => this.$router.push({ name: "quotes" });
        this.pendingCancel = null;
        this.showLeaveModal = true;
      } else {
        this.$router.push({ name: "quotes" });
      }
    },

    confirmLeave() {
      this.isDirty = false;
      this.showLeaveModal = false;
      const nav = this.pendingNavigation;
      this.pendingNavigation = null;
      this.pendingCancel = null;
      if (nav) nav();
    },

    cancelLeave() {
      this.showLeaveModal = false;
      const cancel = this.pendingCancel;
      this.pendingNavigation = null;
      this.pendingCancel = null;
      if (cancel) cancel();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.initAutocomplete(); // Assicura che il DOM sia caricato
    });
    window.addEventListener("scroll", this.updateDropdownPosition, true);
    this._beforeUnloadHandler = (e) => {
      if (this.isDirty) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", this._beforeUnloadHandler);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.updateDropdownPosition, true);
    window.removeEventListener("beforeunload", this._beforeUnloadHandler);
  },

  watch: {
    formData: {
      deep: true,
      handler() {
        this.isDirty = true;
      },
    },
    "newItem.subItem"(val) {
      if (val) {
        this.newItem.price = "0.00";
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === "login") {
      next();
      return;
    }
    if (this.isDirty) {
      this.pendingNavigation = () => next();
      this.pendingCancel = () => next(false);
      this.showLeaveModal = true;
    } else {
      next();
    }
  },
};
</script>

<style src="@/css/CreateQuotePage.css"></style>
